import HomeService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FIRST_STEP, SECOND_STEP, ZERO_STEP } from "./endpoints";
export default {
  namespaced: true,
  state: () => ({
    loading: false,
    id: null,
    ngoId: null,
    firstId: null,
  }),
  getters: {
    loading(state) {
      return state.loading;
    },
    id(state) {
      return state.id;
    },
    ngoId(state) {
      return state.ngoId;
    },
    firstId(state) {
      return state.firstId;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setId(state, val) {
      state.id = val;
    },
    setNgoId(state, val) {
      state.ngoId = val;
    },
    setFirstId(state, val) {
      state.firstId = val;
    },
  },
  actions: {
    async verifyCode({ commit, state }, payload) {
      commit("setLoading", true);
      const data = await HomeService.verifyCode({
        id: state.id,
        code: payload,
      });
      if (data.status >= 400 && data.status <= 500) {
        commit("setLoading", false);
        return Promise.reject();
      }
      commit("setLoading", false);
      return Promise.resolve();
    },
    async changeCurent({ commit, state }, payload) {
      commit("setLoading", true);
      const data = await HomeService.changeCurent({
         payload,
      });
      if (data.status >= 400 && data.status <= 500) {
        commit("setLoading", false);
        return Promise.reject();
      }
      commit("setLoading", false);
      return Promise.resolve();
    },
    async proceedToNextStep({ commit, state }, payload) {
      commit("setLoading", true);
      const data = await HomeService.proceedToNextStep(payload);

      if (data.errors) {
        commit("setLoading", false);
        for (const key in data.errors) {
          if (Object.hasOwnProperty.call(data.errors, key)) {
            const element = data.errors[key][0];
            this._vm.$toast({
              component: ToastificationContent,
              props: {
                title: "خطأ في البيانات",
                icon: "AlertCircleIcon",
                text: element,
                variant: "danger",
              },
            });
          }
        }
        return Promise.reject();
      }
      if (payload.ep === ZERO_STEP) commit("setFirstId", data.data.id);
      if (payload.ep === FIRST_STEP(state.firstId))
        commit("setId", data.data.id);
      if (payload.ep === SECOND_STEP) commit("setNgoId", data.data.id);
      commit("setLoading", false);
      return Promise.resolve();
    },
  },
};
